<template>
  <div class="official-website-article-dialog">
    <el-dialog
      class="official-website-article dialogArticleVisible"
      width="1000px"
      top="10vh"
      @close="dialogClose"
      :visible.sync="showOfficialWebsiteArticle"
      :show-close="false"
    >
      <h2>选择文章</h2>
      <div class="form">
        <!-- 选择数据源 -->
        <div class="data-source-selector clearfix">
          <span class="selector-label">选择数据源：</span>
          <el-radio-group
            v-model="selectedDataSource"
            class="data-source-radio-group"
          >
            <el-radio
              v-for="(item, index) in dataSourceList"
              :key="item.siteCode"
              :label="item.siteCode"
            >
              {{ item.siteName }}
            </el-radio>
          </el-radio-group>
        </div>

        <div
          class="fl clearfix"
          v-if="
            taskInfo.type === 2 ||
              taskInfo.type === '专题' ||
              (type === 'email' && taskInfo.type === 4)
          "
        >
          <span class="tj_year fl">内容类型:</span>
          <el-select
            v-model="chooseTypeVal"
            placeholder="请选择"
            class="fl"
            style="width:120px;top: 3px;"
            @change="chooseTypeChange"
          >
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="fl clearfix" v-if="chooseTypeVal === 2">
          <span class="tj_year fl">选择专题:</span>
          <el-select
            v-model="chooseTopicVal"
            placeholder="请选择"
            class="fl"
            style="width:120px;top: 3px;"
            @change="chooseTopicChange"
          >
            <el-option
              v-for="item in topicOption"
              :key="item.subjectName"
              :label="item.subjectName"
              :value="item.subjectName"
            />
          </el-select>
        </div>
        <div class="fl clearfix" v-if="chooseTypeVal === 1">
          <span class="tj_year fl">选取年份:</span>
          <el-select
            v-model="chooseYearVal"
            placeholder="请选择"
            class="fl"
            style="width:120px;top: 3px;"
            @change="chooseYearChange"
          >
            <el-option
              v-for="item in getYearOption(options)"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="fl clearfix" v-if="chooseTypeVal === 1">
          <span class="tj_year fl">选取刊期:</span>
          <el-select
            v-model="chooseIssueVal"
            placeholder="请选择"
            class="fl"
            style="width:120px;top: 3px;"
            @change="chooseIssueChange"
          >
            <el-option
              v-for="item in getIssueOption(options)"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="fl clearfix">
          <span class="tj_year fl">栏目:</span>
          <el-select
            v-model="columnVal"
            clearable
            placeholder="请选择"
            class="fl"
            style="width:120px;top: 3px;"
            @change="columnChange"
          >
            <el-option
              v-for="item in columnOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <el-button
          class="fr download"
          type="text"
          icon="el-icon-xz"
          @click="
            () => {
              handleDownloadIssueArticles();
            }
          "
          >下载</el-button
        >
        <!-- 文章列表 -->
        <SimpleTable
          ref="articleTableData"
          maxHeight="400"
          style="width:100%;margin-top:50px"
          noSerial
          noPagination
          :showChoose="showChoose"
          :hasSelect="
            articleType == 1 || (chooseTypeVal === 2 && taskInfo.type !== 4)
          "
          :tableData="articleTableData"
          :columnData="articleColumn"
          @onRowClick="handleRowClick"
          @onClickTitle="handleOpenUrl"
          @onChangeInput="handleOfficialWebsiteArticleChangeInput"
          @onChangeInputBlur="handleOfficialWebsiteArticleChangeInputBlur"
        />
        <div slot="footer" class="dialog-footer" style="margin-top:30px">
          <el-button type="primary" @click="saveOfficialArticle"
            >确 定</el-button
          >
          <el-button @click="showOfficialWebsiteArticle = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SimpleTable from "@/components/SimpleTable";
import { mapGetters } from "vuex";
import {
  exportIssueArticles,
  SaveOfficialArticle,
  UpdateArticleUrl,
  SaveOfficialArticleForWeChat,
  GetSubjectList,
  GetSubjectArticles,
  GetFirstArticles,
  GetArticleColumnNew,
  GetYearIssuesNew,
  GetIssueArticlesNew,
  SaveOfficialArticleNew,
  GetDataSource,
  GetSubjectArticlesNew,
  SaveOfficialArticleForWeChatNew
} from "@/api/selfPush";
import { GetMagDetail } from "@/api/detail";
export default {
  name: "officialWebsiteArticleDialog",
  computed: {
    ...mapGetters({
      platMagId: "platMagId",
      platTenantId: "platTenantId",
      platMagName: "platMagName",
      magId: "magId"
    }),
    currentTabName() {
      return this.currentTabIndex == 1 ? "邮件推送" : "微网刊";
    },
    showChooseType() {
      return this.taskInfo.type === 2 ? ture : false;
    },
    showChoose: {
      get() {
        if (this.taskInfo.type === 4) {
          // 单篇
          return this.articleType != 1;
        }
        if (this.chooseTypeVal === 2) {
          // 非单篇专题不展单选
          return false;
        }
        return this.chooseTypeVal === 2 || this.chooseTypeVal === 3;
      },
      set() {}
    }
  },
  props: {
    type: {
      type: String,
      default: "" // 区分邮件和微网刊
    },
    topic: {
      type: String,
      default: ""
    },
    publicationTopic: {
      type: String,
      default: ""
    },
    taskId: {
      // type: Number,
      default: null
    },
    taskInfo: {
      typeof: Object,
      return: {}
    }
  },
  components: {
    SimpleTable
  },
  data() {
    return {
      articleType: null,
      basicInfo: "",
      chooseTypeVal: 1,
      chooseTopicVal: "",
      chooseYearVal: "",
      chooseIssueVal: "",
      showOfficialWebsiteArticle: false,
      options: [],
      articleTableData: [],
      articleTableDataAll: [],
      currentTabIndex: 1,
      // 数据源相关
      dataSourceList: [], // 数据源列表
      selectedDataSource: "", // 当前选中的数据源（siteCode）
      // 防抖定时器
      subjectArticlesTimer: null,
      articleColumn: [
        {
          title: "推送文章标题",
          prop: "title",
          notSortable: true,
          special: true
        },
        {
          title: "栏目",
          prop: "columnBelong",
          notSortable: true,
          special: true
        },
        {
          title: "机构",
          prop: "institutions",
          notSortable: true
        },
        {
          title: "作者",
          prop: "authors",
          notSortable: true
        },
        {
          title: "刊期",
          prop: "issue",
          notSortable: true,
          width: 50
        },
        {
          title: "关键词",
          prop: "keywords",
          notSortable: true
        },
        {
          title: "URL",
          prop: "url",
          notSortable: true,
          edit: true
        }
      ],
      typeOption: [
        {
          label: "整期",
          value: 1
        },
        {
          label: "专题",
          value: 2
        }
      ],
      topicOption: [],
      chooseId: "",
      columnVal: "",
      columnOptions: []
    };
  },
  watch: {
    async magId() {
      await this.getDataSourceList();
      this.getMagDetail();
      // 在数据源列表获取完成后，根据情况调用 getYearIssuesNew
      if (this.selectedDataSource && this.chooseTypeVal !== 2) {
        this.getYearIssuesNew();
      }
      if (this.taskInfo.type === 2) {
        this.getSubjectList();
      }
    },
    selectedDataSource(newVal, oldVal) {
      if (newVal && oldVal !== undefined) {
        if (this.chooseTypeVal !== 2) {
          this.getYearIssuesNew();
        }
        if (this.taskInfo.type === 2) {
          this.getSubjectList();
        }
      }
    },
    chooseTypeVal(n) {
      if (n === 1) {
        this.getYearIssuesNew();
      }
      if (n === 2) {
        this.getSubjectList();
      }
      if (n === 3) {
        this.getFirstArticles();
      }
    },
    chooseTopicVal(newVal) {
      // 只有当选中的是专题类型时才调用
      if (newVal && this.chooseTypeVal === 2 && this.selectedDataSource) {
        this.debounceGetSubjectArticles();
      }
    },
    // 弹窗打开时，根据当前状态「按需」拉取数据，避免已预加载时重复请求
    showOfficialWebsiteArticle(newVal) {
      if (!newVal || !this.magId) return;

      if (this.chooseTypeVal === 1 && this.selectedDataSource) {
        if (!this.options.length || !this.articleTableData.length) {
          this.getYearIssuesNew();
        }
      }

      if (this.chooseTypeVal === 2) {
        if (!this.topicOption.length || !this.articleTableData.length) {
          this.getSubjectList();
        }
      }

      if (this.chooseTypeVal === 3) {
        if (!this.articleTableData.length) {
          this.getFirstArticles();
        }
      }
    }
  },
  mounted() {
    if (this.magId) {
      this.getDataSourceList();
      this.getMagDetail();


      if (this.taskInfo.type === 4) {
        this.getFirstArticles();
        this.typeOption = [
          {
            label: "整期",
            value: 1
          },
          {
            label: "专题",
            value: 2
          },
          {
            label: "优先出版",
            value: 3
          }
        ];
      }
    }
  },
  beforeDestroy() {
    // 清理防抖定时器，避免内存泄漏
    if (this.subjectArticlesTimer) {
      clearTimeout(this.subjectArticlesTimer);
      this.subjectArticlesTimer = null;
    }
  },
  methods: {
    /**
     * 获取数据源列表
     * 从接口获取可用的数据源并默认选中第一项
     */
    async getDataSourceList() {
      try {
        // 判断路由中是否包含字符串contentConfigure
        const isEmail = this.$route.path.includes("contentConfigure");
        const params = { magId: this.magId, type: isEmail ? 0 : 1 };
        const response = await GetDataSource(params);
        if (response && response.data && response.data.status === 0) {
          const { data } = response.data;

          if (data && Array.isArray(data) && data.length > 0) {
            this.dataSourceList = data;
            // 默认选中第一项
            this.selectedDataSource = data[0].siteCode;
          } else {
            this.dataSourceList = [];
            this.selectedDataSource = "";
          }

        } else {
          const message = response.data?.message || "获取数据源失败";
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error("获取数据源失败，请稍后重试");
      }
    },

    columnChange() {
      // this.getIssueArticleData()
      if (this.columnVal) {
        this.articleTableData = this.articleTableDataAll.filter(
          item => item.columnBelong === this.columnVal
        );
      } else {
        this.articleTableData = this.articleTableDataAll;
      }
    },
    getArticleColumn() {
      this.columnVal = "";
      let params = {
        magId: this.magId,
        year: this.chooseYearVal,
        issue: this.chooseIssueVal,
        siteCode: this.selectedDataSource
      };
      GetArticleColumnNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.columnOptions = res.data.data;
        }
      });
    },
    //获取当前期刊基本信息
    getMagDetail() {
      const params = {
        id: this.magId
      };
      GetMagDetail(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.basicInfo = data;
        } else {
          const { message } = res.data;
          this.$message.error(message);
        }
      });
    },
    //根据任务id获取期刊刊期列表
    getYearIssuesNew(val) {
      let params = {
        magId: this.magId,
        siteCode: this.selectedDataSource
      };
      GetYearIssuesNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.options = data;
          if (data.length > 0) {
            if (val === "click") {
              this.dialogArticleVisible = true;
            }
            this.chooseYearVal = this.getYearOption(this.options)[0];
            this.chooseIssueVal = this.getIssueOption(this.options)[0];
            // 仅调 getIssueArticleData，其成功回调内会调用 getArticleColumn，避免重复请求
            this.getIssueArticleData();
          }
        }
      });
    },
    //根据年份和刊期获取文章列表
    getIssueArticleData() {
      this.articleTableData = [];
      this.articleTableDataAll = [];
      const params = {
        magId: this.magId,
        year: this.chooseYearVal,
        issue: this.chooseIssueVal,
        siteCode: this.selectedDataSource
      };
      GetIssueArticlesNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          // 直接使用新接口返回的数据，不做字段映射
          this.articleTableData = res.data.data || [];
          this.articleTableDataAll = JSON.parse(
            JSON.stringify(this.articleTableData)
          );
          this.chooseId = "";
          this.getArticleColumn();
        } else {
          const { message = "" } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 专题列表查询
    getSubjectList() {
      const params = {
        magId: this.magId
      };
      GetSubjectList(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.topicOption = data;
          this.chooseTopicVal = data[0] ? data[0].subjectName : "";
          this.debounceGetSubjectArticles();
        } else {
          const { message = "" } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 优先论文查询
    getFirstArticles() {
      const params = {
        magId: this.magId,
        size: 999
      };
      GetFirstArticles(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.articleTableData = data.content;
          this.articleTableData.map((item, index) => {
            item.handleJumpUrl = item.htmlUrl
              ? item.htmlUrl
              : item.officialWebsiteUrl
              ? item.officialWebsiteUrl
              : "";
          });
        } else {
          const { message = "" } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 防抖获取专题文章（避免重复调用）
    debounceGetSubjectArticles() {
      // 清除之前的定时器
      if (this.subjectArticlesTimer) {
        clearTimeout(this.subjectArticlesTimer);
      }
      // 设置新的定时器
      this.subjectArticlesTimer = setTimeout(() => {
        this.getSubjectArticles();
      }, 100); // 100ms 防抖延迟
    },
    // 获取专题文章
    getSubjectArticles() {
      // 检查必要参数
      if (!this.chooseTopicVal || !this.selectedDataSource) {
        return;
      }
      this.articleTableData = [];
      const params = {
        magId: this.magId,
        subjectName: this.chooseTopicVal,
        siteCode: this.selectedDataSource
      };
      GetSubjectArticlesNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.articleTableData = data || [];
          this.articleTableData.map((item, index) => {
            item.handleJumpUrl = item.htmlUrl
              ? item.htmlUrl
              : item.officialWebsiteUrl
              ? item.officialWebsiteUrl
              : "";
          });
        } else {
          const { message = "" } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 官网文章获取年
    /**
     * 获取年份选项
     * 从新的数据结构中提取所有年份
     * 数据结构：[{ year: "2025", issues: [...] }]
     */
    getYearOption(options) {
      if (!options || !Array.isArray(options)) {
        return [];
      }
      return options.map(item => item.year);
    },

    /**
     * 获取刊期选项
     * 根据选中的年份，从新的数据结构中提取对应的刊期列表
     * 数据结构：[{ year: "2025", issues: [{ issue: "04" }, { issue: "03" }] }]
     */
    getIssueOption(options) {
      if (!options || !Array.isArray(options)) {
        return [];
      }

      // 找到选中年份对应的数据
      const yearData = options.find(item => item.year === this.chooseYearVal);

      if (!yearData || !yearData.issues || !Array.isArray(yearData.issues)) {
        return [];
      }

      // 提取刊期列表
      return yearData.issues.map(issueItem => issueItem.issue);
    },
    // 微网刊弹窗内容类型改变
    chooseTypeChange() {
      this.chooseTopicVal = "";
      this.$refs.articleTableData.initData();
      this.chooseId = "";
    },
    // 微网刊弹窗专题改变
    chooseTopicChange() {},
    // 微网刊弹窗年份改变
    chooseYearChange() {
      this.chooseIssueVal = this.getIssueOption(this.options)[0];
      this.getArticleColumn();
      this.getIssueArticleData();
    },
    // 微网刊弹窗期改变
    chooseIssueChange() {
      this.getArticleColumn();
      this.getIssueArticleData();
    },
    // 下载
    handleDownloadIssueArticles() {
      window.open(
        `${exportIssueArticles}?magId=${this.magId}&year=${this.chooseYearVal}&issue=${this.chooseIssueVal}&column=${this.columnVal}&page=size=100&sort=sequence,asc`,
        "_self"
      );
    },
    // 跳转页面
    handleOpenUrl(chooseItem, columnItem) {
      if (chooseItem["url"]) {
        window.open(chooseItem["url"]);
      }
    },
    // 处理微网刊弹窗文章列表切换为input框
    handleOfficialWebsiteArticleChangeInput() {},
    // 处理微网刊弹窗文章列表为input框时失焦事件
    handleOfficialWebsiteArticleChangeInputBlur(
      val,
      prop,
      event,
      index,
      content,
      id
    ) {
      let params = {
        articleId: id,
        url: content || ""
      };
      UpdateArticleUrl(params).then(resp => {
        let { data, status } = resp.data;
        if (status !== 0) {
          this.$message({
            type: "error",
            message: data.message
          });
          this.getIssueArticleData();
        } else {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.getIssueArticleData();
        }
      });
    },
    // 列表选中数据确定
    saveOfficialArticle() {
      const chooseList = [...this.$refs.articleTableData?.chooseList];
      if (!this.articleTableData.length) {
        this.$message.error("暂无文章可选");
        return;
      }
      let articleIds = "";
      if (this.taskInfo.type === 4) {
        articleIds = chooseList.map(v => v.articleId).join();
      } else if (this.chooseTypeVal === 2 && chooseList.length > 0) {
        articleIds = chooseList.map(v => v.articleId).join();
      } else {
        this.articleTableData.map((item, index) => {
          articleIds =
            articleIds +
            item.articleId +
            (index === this.articleTableData.length - 1 ? "" : ",");
        });
      }
      if (this.type === "email") {
        this.emailBtn(articleIds, chooseList);
      }
      if (this.type === "weChat") {
        this.weChatBtn(articleIds);
      }
    },
    // 邮件确定
    emailBtn(articleIds, chooseList) {
      let params = {};
      if (this.taskInfo.type === 1) {
        // 整期
        params = {
          taskId: this.taskId,
          operator: sessionStorage.getItem("realName"),
          year: this.chooseYearVal,
          issue: this.chooseIssueVal
        };
      } else if (this.taskInfo.type === 2) {
        // 专题
        if (this.chooseTypeVal == 2) {
          params = {
            taskId: this.taskId,
            operator: sessionStorage.getItem("realName")
          };
          if (chooseList.length) {
            params.articleIds = articleIds;
          } else {
            params.subjectName = this.chooseTopicVal;
          }
        } else {
          params = {
            taskId: this.taskId,
            operator: sessionStorage.getItem("realName"),
            year: this.chooseYearVal,
            issue: this.chooseIssueVal
          };
        }
      } else {
        params = {
          taskId: this.taskId,
          articleIds: articleIds,
          operator: sessionStorage.getItem("realName")
        };
        if (this.articleType) params.articleType = 1;
      }
      params.column = this.columnVal;
      params.siteCode = this.selectedDataSource;
      SaveOfficialArticleNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.showOfficialWebsiteArticle = false;
          this.$message({
            type: "success",
            message: "设置成功"
          });
          this.$emit("SaveOfficialArticle");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 微网刊确定
    weChatBtn(articleIds) {
      let params = {
        magId: this.magId,
        topic: this.publicationTopic,
        articleIds: articleIds,
        magName: this.platMagName,
        year: this.chooseYearVal,
        issue: this.chooseIssueVal,
        networkId: this.taskId
      };
      params.siteCode = this.selectedDataSource;
      SaveOfficialArticleForWeChatNew(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.showOfficialWebsiteArticle = false;
          this.$emit("SaveOfficialArticle");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // dialog关闭
    dialogClose() {
      // 重置所有选择值
      this.chooseTypeVal = 1;
      this.chooseTopicVal = "";
      this.chooseYearVal = "";
      this.chooseIssueVal = "";
      this.columnVal = "";
      this.chooseId = "";
      this.articleType = null;

      // 清空数据列表
      this.articleTableData = [];
      this.articleTableDataAll = [];
      this.options = [];
      this.topicOption = [];
      this.columnOptions = [];

      // 重置数据源为第一个（如果有数据源列表）
      if (this.dataSourceList && this.dataSourceList.length > 0) {
        this.selectedDataSource = this.dataSourceList[0].siteCode;
      }

      // 清空表格选中状态
      if (this.$refs.articleTableData) {
        this.$refs.articleTableData.initData();
      }
    },
    // 点击每一篇文章时 类型为单篇任务
    handleRowClick(chooseId, row) {
      this.chooseId = chooseId;
    }
  }
};
</script>

<style lang="scss" scoped>
.official-website-article {
  padding: 0px;
  h2 {
    text-align: left;
    background: #265cca;
    padding: 10px;
    color: white;
    height: 30px;
  }
  .download {
    margin-right: 20px;
  }
}
.form span {
  line-height: 34px;
  margin-right: 10px;
  margin-left: 20px;
}
.tj_year {
  font-size: 14px;
  font-weight: 600;
}

// 数据源选择器样式
.data-source-selector {
  margin-bottom: 4px;
  text-align: left;

  .selector-label {
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    margin-right: 15px;
    line-height: 32px;
  }

  .data-source-radio-group {
    display: inline-block;

    .el-radio {
      margin-right: 20px;
      line-height: 32px;

      &:last-child {
        margin-right: 0;
      }
    }

    // 修改选中状态的颜色
    ::v-deep .el-radio__input.is-checked {
      .el-radio__inner {
        border-color: #265cca;
        background: #265cca;
      }
    }

    // 修改选中状态的文字颜色
    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #265cca;
    }
  }
}
</style>
<style lang="scss">
.official-website-article-dialog {
  .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0.3) !important;
  }
}
</style>
